export const getCurrentDomainWithoutSubPath = (): string => {
  return `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;
}
